import dayjs from "dayjs";

/**
 * Định dạng số tiền đầy đủ kèm đơn vị VNĐ theo định dạng en-US (phân cách hàng nghìn bằng dấu phẩy)
 * Ví dụ: 1250000 -> "1,250,000 đ"
 */
export const formatCurrency = (val) => {
  const num = Number(val);
  if (isNaN(num)) return "0 đ";
  return num.toLocaleString("en-US") + " đ";
};

/**
 * Định dạng số thông thường dùng en-US
 */
export const formatNumber = (val) => {
  const num = Number(val);
  if (isNaN(num)) return "0";
  return num.toLocaleString("en-US");
};

/**
 * Định dạng rút gọn số tiền hiển thị trên trục biểu đồ và huy hiệu
 * Ví dụ: 1.500.000.000 -> "1.5 tỷ"; 50.000.000 -> "50tr"; 150.000 -> "150k"
 */
export const formatShortMoney = (val) => {
  if (!val || val === 0) return "0";
  const num = Number(val);
  if (isNaN(num)) return "0";

  if (Math.abs(num) >= 1_000_000_000) {
    const b = num / 1_000_000_000;
    const formatted = b % 1 === 0 ? b : b.toFixed(2);
    return `${formatted} tỷ`;
  }
  if (Math.abs(num) >= 1_000_000) {
    const m = num / 1_000_000;
    const formatted = m % 1 === 0 ? m : m.toFixed(1);
    return `${formatted}tr`;
  }
  if (Math.abs(num) >= 1_000) {
    const k = num / 1_000;
    const formatted = k % 1 === 0 ? k : k.toFixed(0);
    return `${formatted}k`;
  }
  return `${num.toLocaleString("en-US")}`;
};

/**
 * Giới hạn tối đa của BE cho từng loại kỳ thống kê:
 * - day: tối đa 7 ngày
 * - month: tối đa 6 tháng
 * - year: tối đa 6 năm
 */
export const PERIOD_LIMITS = {
  day: { amount: 7, unit: "day", label: "7 ngày" },
  month: { amount: 6, unit: "month", label: "6 tháng" },
  year: { amount: 6, unit: "year", label: "6 năm" },
};

/**
 * Tính toán khoảng ngày mặc định hợp lệ cho từng loại kỳ
 */
export const getDefaultDateRange = (periodType) => {
  const today = dayjs();
  switch (periodType) {
    case "month":
      return {
        fromDate: today.subtract(5, "month").startOf("month").format("YYYY-MM-DD"),
        toDate: today.format("YYYY-MM-DD"),
      };
    case "year":
      return {
        fromDate: today.subtract(5, "year").startOf("year").format("YYYY-MM-DD"),
        toDate: today.format("YYYY-MM-DD"),
      };
    case "day":
    default:
      return {
        fromDate: today.subtract(6, "day").format("YYYY-MM-DD"),
        toDate: today.format("YYYY-MM-DD"),
      };
  }
};

/**
 * Kiểm tra xem khoảng ngày có vượt quá giới hạn cho phép của backend không
 */
export const validateDateRange = (periodType, fromDate, toDate) => {
  const from = dayjs(fromDate);
  const to = dayjs(toDate);

  if (!from.isValid() || !to.isValid()) {
    return { valid: false, error: "Ngày không hợp lệ" };
  }
  if (from.isAfter(to)) {
    return { valid: false, error: "Từ ngày không được lớn hơn Đến ngày" };
  }

  const limit = PERIOD_LIMITS[periodType];
  if (limit && to.isAfter(from.add(limit.amount, limit.unit))) {
    return {
      valid: false,
      error: `Thống kê theo ${
        periodType === "day" ? "ngày" : periodType === "month" ? "tháng" : "năm"
      } chỉ cho phép tối đa ${limit.label}`,
    };
  }

  return { valid: true };
};
